import gl_1 from '../img/Raytracer.png';
import gl_2 from '../img/Train_Hero.gif';
import gl_3 from '../img/Train_Station.gif';
import bh_1 from '../img/Beat Hero 1.png';
import bh_2 from '../img/Beat Hero 2.png';
import bh_3 from '../img/Beat Hero 3.png';
import mpr_1 from '../img/Missing Persons Report 1.png';
import mpr_2 from '../img/Missing Persons Report 2.png';
import mpr_3 from '../img/Missing Persons Report 3.png';

import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import YouTubeIcon from '@mui/icons-material/YouTube';
import GitHubIcon from '@mui/icons-material/GitHub';

function Projects() {
    return (
        <div className="Projects">
            <br/>
            <div className="row Project 1">
                <div className="column left">
                    <strong>OpenGL Computer Graphics</strong>
                    <br/>
                    <Carousel showArrows={true} showThumbs={false} useKeyboardArrows={true}>
                        <div>
                        <img src={gl_1} alt="Raycasting"/>
                        <p className="legend">A raycast scene</p>
                        </div>
                        <div>
                        <img src={gl_2} alt="Train scene"/>
                        <p className="legend">A train following a track</p>
                        </div>
                        <div>
                        <img src={gl_3} alt="Train at station"/>
                        <p className="legend">A train arriving at a station</p>
                        </div>
                    </Carousel>
                </div>
                <div className="column right">
                    <Tooltip title="Source code">
                    <IconButton>
                        <a href="https://github.com/CrazyMorgan0/OpenGL_Graphics" target="_blank" rel="noreferrer">
                        <GitHubIcon fontSize="large"/>
                        </a>
                    </IconButton>
                    </Tooltip>
                    <br/>
                    Using C++ and the OpenGL (v2.0) pipeline
                    <br/>
                    <ul>
                    <li>Understand the implementation of raycasting in order to create a scene with realistic reflections and refractions</li>
                    <br/>
                    <li>Create a looped animation of a train moving around a track</li>
                    <br/>
                    <li>Create models and use textures to add realism to scenes</li>
                    </ul>
                </div>
            </div>
            <p>
            <h3>Games</h3>
            My passion for computers came from playing video games.
            I wanted to learn the magic behind how video games and websites were made, and how computers use machinery, electricity and programs to make that happen.
            These are games that I have developed solo for VR, using the Unity game engine.
            </p>
            <div className="row project_2">
                <div className="column left">
                    <strong>Beat Hero</strong>
                    <br/>
                    <Carousel showArrows={true} showThumbs={false} useKeyboardArrows={true}>
                        <div>
                        <img src={bh_1} alt="Gameplay"/>
                        </div>
                        <div>
                        <img src={bh_2} alt="Double points mode"/>
                        </div>
                        <div>
                        <img src={bh_3} alt="Beat Hero menu"/>
                        </div>
                    </Carousel>
                </div>
                <div className="column right">
                    <Tooltip title="Source code">
                    <IconButton>
                        <a href="https://github.com/CrazyMorgan0/BeatHero" target="_blank" rel="noreferrer">
                        <GitHubIcon fontSize="large"/>
                        </a>
                    </IconButton>
                    </Tooltip>
                    <Tooltip title="Gameplay">
                    <IconButton>
                        <a href="https://youtu.be/0LRsObVziHk" target="_blank" rel="noreferrer">
                        <YouTubeIcon fontSize="large"/>
                        </a>
                    </IconButton>
                    </Tooltip>
                    <br/>
                    Genre: A fun rhythm game designed for fitness
                    <br/>
                    <br/>
                    Gameplay:
                    <br/>
                    <ul>
                    <li>Slashing the same beat multiple times, encouraging players to slice as many times as they can while it's in range</li>
                    <br/>
                    <li>Players are encouraged to crouch to avoid losing points</li>
                    <br/>
                    <li>Pontential for infinite songs with a competitive scoring system.</li>
                    </ul>
                </div>
            </div>
            <div className="row project_3">
                <div className="column left">
                    <strong>Missing Persons Report</strong>
                    <br/>
                    <Carousel showArrows={true} showThumbs={false} useKeyboardArrows={true}>
                        <div>
                        <img src={mpr_1} alt="Kate in the basement"/>
                        </div>
                        <div>
                        <img src={mpr_2} alt="Craft knife handle in the bathroom"/>
                        </div>
                        <div>
                        <img src={mpr_3} alt="Basement door"/>
                        </div>
                    </Carousel>
                </div>
                <div className="column right">
                    <Tooltip title="Source code">
                    <IconButton>
                        <a href="https://github.com/CrazyMorgan0/MissingPersonsReport" target="_blank" rel="noreferrer">
                        <GitHubIcon fontSize="large"/>
                        </a>
                    </IconButton>
                    </Tooltip>
                    <Tooltip title="Gameplay">
                    <IconButton>
                        <a href="https://youtu.be/TO-DzFAoN9Y" target="_blank" rel="noreferrer">
                        <YouTubeIcon fontSize="large"/>
                        </a>
                    </IconButton>
                    </Tooltip>
                    <br/>
                    Genre: Interactive narrative experience
                    <br/>
                    <br/>
                    Gameplay:
                    <br/>
                    <ul>
                    <li>Play as the police in an investigation about a missing woman.</li>
                    <br/>
                    <li>Search the rooms for items and evidence.</li>
                    <br/>
                    <li>Interesting and quick thriller story designed to be a prototype scene for a police themed game.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Projects;